export const defaultValues = ({ first_name, last_name, dob }) => ({
  name: `${first_name} ${last_name}`,
  start_date: null,
  risk_reasons: {
    COSTB: false,
    SABUSE: false,
    ABUSED: false,
    DOMVIO: false,
    NEGLEC: false,
    ABPAST: false,
    SAPAST: false,
    VIPAST: false,
    NEGPST: false
  },
  indicative_risk_to_date: null,
  evidence: [],
  evidence_held: true,
  evidence_additional_infor: '',
  declaration_given: true,
  state_details: {
    first_name: '',
    last_name: '',
    additional_infor: '',
    date_of_notice: null,
    org_name: '',
    body_type: 'CODE01',
    ref_number: '',
    person_id: '',
    person_phone: '',
    person_email: '',
    notified_third_party: false,
    third_party_notified_me: false
  },
  child_dob: dob,
  weeks_at_risk: 1,
  extension_reasons: {
    LONGPO: false,
    FOSKIN: false
  },
  reason_no_3rd_party: '',
  exceptional_circumstance_reason: '',
  exceptional_circumstance_text: ''
})

export const getRisksArray = ({risk_reasons}) => {
  let risk = []
  for (let val in risk_reasons) {
    if (risk_reasons[val]) {
      risk.push(val)
    }
  }

  return risk
}

export const getExtensionsArray = ({extension_reasons}) => {
  let ext = []
  for (let val in extension_reasons) {
    if (extension_reasons[val]) {
      ext.push(val)
    }
  }

  return ext
}


export const submissionToForm = (child, submission) => {
  return {
    ...submission,
    name: `${child.first_name} ${child.last_name}`,
    risk_reasons: submission.risk_reasons.reduce((obj, key) => {
      return {
        ...obj,
        [key]: true
      }
    }, {}),
    state_details: submission.state_details 
      ? submission.state_details
      : defaultValues(child).state_details
  }
}

export const validateStateDetails = (state_details) => {
  let valid = false
  
  valid = valid || state_details.org_name
  valid = valid || state_details.ref_number
  valid = valid || state_details.person_id
  valid = valid || state_details.person_phone
  valid = valid || state_details.person_email
  valid = valid || state_details.first_name
  valid = valid || state_details.last_name
  valid = valid || state_details.additional_infor

  return valid
}

export const calculateDeterminationSubmitValues = (values) => {
  let risk = getRisksArray(values)
  let extension = getExtensionsArray(values)

  const submitValues = { ...values, risk_reasons: risk, extension_reasons: extension }

  delete submitValues.name

  return submitValues
}



// WEBPACK FOOTER //
// ./src/accs-gov-enrolments/helpers.js